// src/context/PendingRequestsContext.js
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const PendingRequestsContext = createContext();

export function PendingRequestsProvider({ children }) {
  const [pendingRequestsCount, setPendingRequestsCount] = useState(0);

  const role = localStorage.getItem('role');

  const refreshCount = useCallback(async () => {
    try {
      let endpoint = '';
      if (role === 'manager') {
        endpoint = '/manager/vacation-requests/pending-count';
      } else if (role === 'hr_admin') {
        endpoint = '/admin/vacation-requests/pending-count';
      } else if (role === 'ceo') {
        endpoint = '/ceo/vacation-requests/pending-count';
      } else if (role === 'finance') {
        endpoint = '/finance/vacation-requests/pending-count';
      }
      if (!endpoint) return;
      const response = await api.get(endpoint);
      setPendingRequestsCount(response.data.count || 0);
    } catch (err) {
      console.error(err);
      setPendingRequestsCount(0);
    }
  }, [role]);

  useEffect(() => {
    if (role === 'manager' || role === 'finance' || role === 'hr_admin' || role === 'ceo') {
      refreshCount();
    }
  }, [role, refreshCount]);

  return (
    <PendingRequestsContext.Provider
      value={{ pendingRequestsCount, refreshCount }}
    >
      {children}
    </PendingRequestsContext.Provider>
  );
}

export function usePendingRequests() {
  return useContext(PendingRequestsContext);
}
